// VersionInfo.js
import InfoLayout from "./InfoLayout";

function VersionInfo() {
  return (
    <InfoLayout title="Version">
      <div>
        <p><strong>Current version number:</strong> v1.1.1</p>
        <p><strong>Release date:</strong> January 09, 2026</p>
        <p><strong>Language:</strong> ENG, English version</p>
        <p><strong>Release notes:</strong> This version represents the first production deployment of the 
        <strong>Tabata Timer</strong> web application. The app is available 
        through a web browser and includes four main functional pages plus an additional <em>About the App</em> page.</p>        
        <p><strong>Changelog:</strong> - </p>
        <p><strong>Bug fixes:</strong> - </p>
      </div>
    </InfoLayout>

  );
}

export default VersionInfo;
